import React, { useRef } from 'react'
import classNames from 'classnames'

import './index.scss'

const Switcher = ({ options, selected, onChange, daily, isDisabled = false }) => {
  const ref = useRef(null)

  const cumulativeIndex = 0
  const periodIndex = daily ? 2 : 1
  const leftLabel = options[cumulativeIndex].label
  const rightLabel = options[periodIndex].label
  return (
    <div className="switcher-container" ref={ref}>
      <div
        key={leftLabel}
        onClick={() => onChange(options[cumulativeIndex])}
        className={classNames('sw-opts', {
          active: options[cumulativeIndex].value === selected.value,
          disabled: isDisabled,
        })}
      >
        <span>{leftLabel}</span>
      </div>

      <div
        key={rightLabel}
        onClick={() => onChange(options[periodIndex])}
        className={classNames('sw-opts', {
          active: options[periodIndex].value === selected.value,
          disabled: isDisabled,
        })}
      >
        <span>{rightLabel}</span>
      </div>
    </div>
  )
}

Switcher.propTypes = {}

Switcher.defaultProps = {
  options: [],
  selected: null,
  onChange: null,
  daily: false,
}

Switcher.displayName = 'Switcher'

export default Switcher
